export const creditCardMeter = {
    showNewCardMeterInTransactions: {
        enabled: false,
        _description: 'Displays the new credit card meter instead of the old one',
    },
    useOutstandingAmountAsMainAmount: {
        enabled: true,
        _description: 'Uses the outstanding amount as main amount only for HR',
    },
    showAbsoluteValueOfOutstandingAmount: {
        enabled: false,
        _description: 'Shows absolute value of the outstanding amount on the overview',
    },
};
